var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-exist[data-v-0cb28182]{width:100%;height:100%;display:flex;align-items:center;justify-content:center;flex-direction:column}.not-exist .error-icon[data-v-0cb28182]{background:url(" + escape(require("image/null.svg")) + ") no-repeat}", ""]);

// exports
